<template>
  <el-form :model="form" label-width="120px" :rules="rules" ref="formRef">
    <el-form-item label="AppKey" prop="login_name">
      <el-input v-model="form.login_name" placeholder="请输入AppKey" />
    </el-form-item>
    <el-form-item label="AppSecret" prop="password">
      <el-input v-model="form.password" placeholder="系统将自动生成AppSecret" :disabled="autoGenerate">
        <template #append>
          <el-checkbox v-model="autoGenerate">自动生成</el-checkbox>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm">提交</el-button>
      <el-button @click="resetForm">重置</el-button>
      <el-button :disabled="!autoGenerate" @click="restartGenerateHast" :type="'warning'" >重新生成</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { generateHash } from '@/utils/sign'

export default {
  data() {
    return {
      form: {
        login_name: '',
        password: ''
      },
      autoGenerate: true,
      isFirstOpen: true,
      rules: {
        login_name: [
          { required: true, message: '请输入AppKey', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入AppSecret', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    async autoGenerate(newVal) {
      if (newVal) {
        this.form.password = await generateHash(this.form.login_name || Date.now().toString())
      } else {
        this.form.password = ''
      }
    }
  },
  mounted() {
    this.$nextTick(async () => {
      if (this.autoGenerate) {
        this.form.password = await generateHash(this.form.login_name || Date.now().toString())
      }
    })
  },
  methods: {
    async restartGenerateHast() {
      this.form.password = await generateHash(this.form.login_name || Date.now().toString())
    },
    async submitForm() {
      try {
        await this.$refs.formRef.validate()
        const formData = { ...this.form }
        if (this.autoGenerate) {
          formData.password = await generateHash(formData.login_name)
        }
        this.$emit('submit', formData)
      } catch (error) {
        console.error('表单验证失败:', error)
      }
    },
    async resetForm() {
      this.$refs.formRef.resetFields()
      if (this.autoGenerate) {
        this.form.password = await generateHash(this.form.login_name || Date.now().toString())
      }
    }
  }
}
</script>
